.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.top {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.label {
  font-size: 14px;
  font-weight: 700;
}

.status {
  font-size: 13px;
  color: var(--ink-3);
}

.error {
  font-size: 13px;
  font-weight: 600;
  color: var(--error);
}

.input {
  width: 100%;
  padding: 10px 12px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 15px;
  line-height: 1.5;
  resize: vertical;
}

/* Lilac once it holds text: private clinician material. */
.written {
  background: var(--private);
  color: var(--private-ink);
}
